import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const educationSchema = itemSchema.extend({
  institution: urlSchema,
  program: z.string().default(""),
  studyType: z.string(),
  area: z.string(),
  score: z.string(),
  date: z.string(),
  summary: z.string(),
  highlights: z.string().optional(),
  url:  z.any(),
});

// Type
export type Education = z.infer<typeof educationSchema>;

// Defaults
export const defaultEducation: Education = {
  ...defaultItem,
  id: "",
  institution: defaultUrl,
  program: "",
  studyType: "",
  area: "",
  score: "",
  date: "",
  summary: "",
  highlights: "",
  url: defaultUrl,
};
